import React, { useEffect } from 'react';
import { useAuthenticatedBlobUrl } from '../../utils/useAuthenticatedBlobUrl';
import '../../pages/Area/Area.css';

interface DetectionPhotoModalProps {
  isOpen: boolean;
  photoUrl: string | null;
  onClose: () => void;
  title?: string;
  fetchLoading?: boolean;
  fetchError?: string | null;
  /** Доп. информация под фото: номер, направление и т.п. */
  meta?: React.ReactNode;
}

const DetectionPhotoModal: React.FC<DetectionPhotoModalProps> = ({
  isOpen,
  photoUrl,
  onClose,
  title = 'Фотофиксация детекции',
  fetchLoading = false,
  fetchError = null,
  meta,
}) => {
  const {
    blobUrl: photoBlobUrl,
    loading: photoLoading,
    error: photoError,
    onImageError,
  } = useAuthenticatedBlobUrl(photoUrl, isOpen && !!photoUrl && !fetchLoading && !fetchError);

  useEffect(() => {
    if (!isOpen) return;

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const canShowImage = !!photoUrl && !fetchLoading && !fetchError;

  return (
    <div className="area-modal" role="dialog" aria-modal="true">
      <div className="area-modal__backdrop" onClick={onClose} />
      <div className="area-modal__dialog area-modal__dialog--photo">
        <header className="area-modal__header">
          <h2 className="area-modal__title">{title}</h2>
          <button
            className="area-modal__close"
            type="button"
            onClick={onClose}
            aria-label="Закрыть"
          >
            ×
          </button>
        </header>

        <div className="area-modal__photo-body">
          {fetchLoading && (
            <div className="area-modal__photo-status">Загрузка…</div>
          )}
          {fetchError && !fetchLoading && (
            <div className="area-modal__photo-status area-modal__photo-status--error">
              {fetchError}
            </div>
          )}
          {canShowImage && photoLoading && (
            <div className="area-modal__photo-status">Загрузка изображения…</div>
          )}
          {canShowImage && photoError && !photoLoading && (
            <div className="area-modal__photo-status area-modal__photo-status--error">
              Ошибка загрузки изображения
            </div>
          )}
          {canShowImage && photoBlobUrl && !photoLoading && !photoError && (
            <img
              src={photoBlobUrl}
              alt="Фотофиксация"
              className="area-modal__photo-img"
              onError={onImageError}
            />
          )}
        </div>

        {meta && <div className="area-modal__photo-meta">{meta}</div>}

        <footer className="area-modal__footer">
          <button
            type="button"
            className="area-modal__submit area-modal__submit--secondary"
            onClick={onClose}
          >
            Закрыть
          </button>
        </footer>
      </div>
    </div>
  );
};

export default DetectionPhotoModal;
